import React, { useMemo } from 'react';
import { Box } from '@material-ui/core';
import ReactPaginate from 'react-paginate';
import { MenuItem, Select } from '@material-ui/core';
import { useTheme } from '@material-ui/core';
import { useIntl } from 'umi';
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined';
import ArrowForwardIosOutlinedIcon from '@material-ui/icons/ArrowForwardIosOutlined';
import PaginationStyled from './PaginationStyled';

export default (props) => {
  const theme = useTheme();
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const { page, total, changePages, mt = 3, showPageSize=true } = props;
  const { pageNum = 1, pageSize = 10 } = page;

  const pageInfo = useMemo(() => {
    const pageCount = Math.ceil(total / pageSize);
    let marginPagesDisplayed;
    let pageRangeDisplayed;
    if (pageCount > 7) {
      marginPagesDisplayed = 2;
      pageRangeDisplayed = 5;
    }
    return { pageRangeDisplayed, marginPagesDisplayed, pageCount };
  }, [total, pageSize]);

  const pageNumMemo = useMemo(() => {
    return pageNum > 0 ? pageNum - 1 : 0;
  }, [pageNum]);

  const changePageNum = (e) => {
    const selectdPageNum = e.selected + 1;
    changePages({ ...page, pageNum: selectdPageNum });
  };

  const changePageSize = (e) => {
    const selectdPageSize = e.target.value;
    changePages({ pageSize: selectdPageSize, pageNum: 1 });
  };

  return (
    <PaginationStyled theme={theme}>
      <Box className="commentBox" mt={mt}>
        <ReactPaginate
          previousLabel={<ArrowBackIosOutlinedIcon className="icon-left" />}
          nextLabel={<ArrowForwardIosOutlinedIcon className="icon-right" />}
          breakLabel={'...'}
          breakClassName={'break-me'}
          pageCount={pageInfo?.pageCount}
          marginPagesDisplayed={pageInfo?.marginPagesDisplayed}
          pageRangeDisplayed={pageInfo?.pageRangeDisplayed}
          onPageChange={changePageNum}
          disableInitialCallback={true}
          containerClassName={'pagination'}
          activeClassName={'active'}
          initialPage={pageNumMemo}
          forcePage={pageNumMemo}
          eventListener="onClick"
        />
        {showPageSize && <span className="page-size">
          <Select
            className="select"
            variant="outlined"
            defaultValue={10}
            value={pageSize}
            onChange={changePageSize}
            label=""
          >
            {[
              {
                id: 10,
                name: `10${formatMessage({
                  id: 'comm.pagination.lbl.06',
                })}/${formatMessage({ id: 'comm.pagination.lbl.05' })}`,
              },
              {
                id: 50,
                name: `50${formatMessage({
                  id: 'comm.pagination.lbl.06',
                })}/${formatMessage({ id: 'comm.pagination.lbl.05' })}`,
              },
              {
                id: 100,
                name: `100${formatMessage({
                  id: 'comm.pagination.lbl.06',
                })}/${formatMessage({ id: 'comm.pagination.lbl.05' })}`,
              },
            ].map((item) => (
              <MenuItem
                key={item.id}
                value={item.id}
                name={item.id}
                // onClick={(id) => {
                //   console.log('id', id);
                //   changePages({ ...page, pageSize: id });
                // }}
              >
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </span>}
      </Box>
    </PaginationStyled>
  );
};
